/* eslint-disable no-restricted-imports */
import { ButtonBase, Stack, Tooltip, Typography } from '@mui/material';
import { formatPrice } from 'integration/utils/formatPrice';

interface DpvaleOptionCardProps {
	selected: boolean;
	distributorName: string;
	recurrent: boolean;
	amount: number | string;
	folio?: string;
	onClick: () => void;
}

export const DpvaleOptionCard = ({
	selected,
	distributorName,
	recurrent,
	amount,
	folio,
	onClick,
}: DpvaleOptionCardProps) => (
	<ButtonBase
		sx={{
			border: '1px solid #E5E5E5',
			height: '80px',
			width: '100%',
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			borderRadius: '5px',
		}}
		onClick={onClick}
	>
		<Stack
			sx={{
				alignItems: 'center',
				justifyContent: 'center',
				paddingX: 2,
				height: '100%',
				width: '136px',
				minWidth: '136px',
				borderRight: '1px solid #E5E5E5',
				backgroundColor: selected ? 'primary.main' : undefined,
				borderTopLeftRadius: '5px',
				borderBottomLeftRadius: '5px',
				transition: 'all 0.3s ease',
			}}
		>
			<Typography
				sx={{
					fontSize: 'var(--font-size-caption)',
					color: selected ? '#FFFFFF' : '#000000',
				}}
			>
				{recurrent ? 'Crédito midp' : 'dpvale'}
			</Typography>
			{folio ? (
				<Tooltip title="Este es tu folio" placement="top">
					<Typography
						sx={{
							fontSize: 'var(--font-size-caption)',
							color: selected ? '#FFFFFF' : '#000000',
						}}
					>
						{folio}
					</Typography>
				</Tooltip>
			) : null}
			<Typography
				sx={{
					fontSize: 'var(--font-size-sm)',
					fontWeight: 800,
					color: selected ? '#FFFFFF' : '#000000',
				}}
			>
				{formatPrice(amount.toString(), 'MXN')}
			</Typography>
		</Stack>
		<Stack
			sx={{
				alignItems: 'flex-start',
				justifyContent: 'center',
				paddingX: 2,
				backgroundColor: '#F3F3F3',
				height: '100%',
				width: '100%',
				borderTopRightRadius: '5px',
				borderBottomRightRadius: '5px',
			}}
		>
			<Typography
				sx={{
					fontSize: 'var(--font-size-caption)',
				}}
			>
				{'Distribuidor'}
			</Typography>

			<Typography
				sx={{
					fontSize: 'var(--font-size-default)',
					WebkitLineClamp: 2,
					display: '-webkit-box',
					WebkitBoxOrient: 'vertical',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					textAlign: 'left',
				}}
			>
				{distributorName}
			</Typography>
		</Stack>
	</ButtonBase>
);
